module.exports = __webpack_public_path__ + "static/media/SL-Application_navigation-globalicon.36be134f.svg";